import {ComponentType, MouseEventHandler, SVGProps} from 'react';

export type IconButtonProps = {
    type?: 'filled' | 'big' | 'big-filled',
    onClick: MouseEventHandler<HTMLButtonElement>
    className?: string,
    icon?: ComponentType<SVGProps<SVGSVGElement>>,
    iconProps?: SVGProps<SVGSVGElement>,
    disabled?: boolean
}

const IconButton = (props: IconButtonProps) => {
    const buttonTypeStyle = (): string => {
        switch (props.type) {
            case 'big':
                return 'dfb-IconButton--big';
            case 'filled':
                return 'dfb-IconButton--filled';
            case 'big-filled':
                return 'dfb-IconButton--filled dfb-IconButton--big';
            default:
                return '';
        }
    };

    const onClick: MouseEventHandler<HTMLButtonElement> = (e) => {
        if (props.onClick && !props.disabled) {
            props.onClick(e);
        }
    };

    // disabled=false is not allowed
    const inactive = props.disabled ? true : undefined;

    return (
        <button className={`dfb-IconButton ${buttonTypeStyle()} ${props.className ?? ''} ${inactive ? 'is-disabled' : ''}`}
                onClick={onClick}
                disabled={inactive}>
            <span className="dfb-Icon dfb-IconButton-icon">
                <props.icon {...props.iconProps} />
            </span>
        </button>
    );
};

export default IconButton;
